import React from "react";
import "./style.css";
import { BiLogoFacebook } from "react-icons/bi";


import { FiPhoneForwarded } from "react-icons/fi";
import { GrMailOption } from "react-icons/gr";
import { useTranslation } from "react-i18next";

export const Footer = () => {
    const { t } = useTranslation();

    return (
        <>
            <div className="footer">
                <div className="footer_contact">
                    <h2>{t('footer.contactUs')}</h2>
                    <div className="footer-content">
                        <p>
                            <span><FiPhoneForwarded /></span> {t('phoneNumberOffice')}
                        </p>
                        <p>
                            <span><GrMailOption /></span>  {t('mail')}
                        </p>
                    </div>
                </div>
                <div className="website">
                    <h2>{t('footer.subscribe')}</h2>
                    <div className="website_icon">
                        <div className="fa">
                            <a href="https://www.facebook.com/profile.php?id=100083102542158" aria-label="Facebook">
                                <BiLogoFacebook />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="footer_text">
                <p>{t("footer_text")}</p>

            </div>
        </>
    );
};
